import "core-js/modules/es.array.push.js";
import { mapState } from 'vuex';
import Bus from '@/assets/js/bus.js';
import AgoraClient from '@/assets/js/rtc-client-ng';
import { handleLocalStorage, getFullscreenEnabled, routerJump } from '@/assets/js/utils.js';
import { controlCamera, controlAudio, controlDevicePublish, changeBehaviorStatus, controlDeviceBehavior } from '@/assets/js/attendUser.js';
import VolumeBar from '@/assets/js/volumeBar.js';
const nodeUrl = require('url');
export default {
  data() {
    return {
      rtc: null,
      devicesInfo: {},
      userInfo: {},
      showLocalVideo: true,
      rtilCode: '',
      rtcLoaded: false,
      partyCode: '',
      nickNameMap: {},
      rtilCodeList: [],
      iconList: ['leaveParty', 'camera', 'mic', 'speaker'],
      videoCanvasWidth: '',
      outputRtilCode: '',
      trackMap: {},
      avatarInfo: {},
      mainwindowInfo: [],
      degreeHost: {},
      fullRotate: false,
      hostControlPipRtilCode: {},
      CameraTips: {
        hideSave: false,
        hideCancel: false,
        showGotIt: false,
        gotIt: 'galleryParticipant.gotIt',
        title: 'galleryParticipant.cameraTips',
        content: '',
        cancel: 'galleryParticipant.deny',
        save: 'galleryParticipant.admit',
        show: false
      },
      updataInfoTimer: null,
      liveInfo: {},
      allRtilCodeList: [],
      slotNumList: {},
      currentSlotNum: 0
    };
  },
  watch: {
    'State.fullScreen': {
      handler: function (val) {
        if (val) {
          this.fullRotate = true;
        } else {
          this.fullRotate = false;
        }
      }
    }
  },
  computed: {
    ...mapState({
      State: state => state
    }),
    showParticipateList() {
      const isOnlyLocal = this.rtilCodeList.length < 2;
      if (isOnlyLocal) {
        this.$nextTick(() => {
          var _this$rtc$_localVideo;
          (_this$rtc$_localVideo = this.rtc._localVideoTrack) === null || _this$rtc$_localVideo === void 0 ? void 0 : _this$rtc$_localVideo.play('local_stream');
        });
      }
      this.changeLayout();
      return this.rtilCodeList.length >= 2;
    },
    returnVideoClass() {
      let _str = '';
      if (!this.degreeHost[this.rtilCode]) {
        _str += !this.State.needLocalMirror ? '' : 'rotate0Mirror';
      } else if (this.degreeHost[this.rtilCode] == 0) {
        _str += !this.State.needLocalMirror ? 'rotate0' : 'rotate0Mirror';
      } else if (this.degreeHost[this.rtilCode] == 90) {
        if (this.fullRotate && this.State.isVertical) {
          _str += !this.State.needLocalMirror ? 'rotateFull90' : 'rotateFull90Mirror';
        } else {
          _str += !this.State.needLocalMirror ? 'rotate90' : 'rotate90Mirror';
        }
      } else if (this.degreeHost[this.rtilCode] == 180) {
        _str += !this.State.needLocalMirror ? 'rotate180' : 'rotate180Mirror';
      } else if (this.degreeHost[this.rtilCode] == 270) {
        if (this.fullRotate && this.State.isVertical) {
          _str += !this.State.needLocalMirror ? 'rotateFull270' : 'rotateFull270Mirror';
        } else {
          _str += !this.State.needLocalMirror ? 'rotate270' : 'rotate270Mirror';
        }
      }
      return _str;
    }
  },
  async created() {
    const URL = nodeUrl.parse(location.href, true);
    this.partyCode = URL.query.id || URL.query.join_id;
    this.currentSlotNum = URL.query.slotNum;
    window.addEventListener('resize', this.changeLayout);
    this.rtc = new AgoraClient(this.agoraCallback);
    // 需要先获取设备列表，并判断之前选择过的设备列表是否还存在，不存在则选择默认的
    this.devicesInfo = await this.rtc.getDevice();
    if (!handleLocalStorage('get', 'speakerId')) {
      handleLocalStorage('set', 'speakerId', this.devicesInfo.speakerId);
    }
    const {
      rtilCode,
      nickName
    } = await this.getBehaviorsByMemberId();
    if (rtilCode && nickName) {
      this.getJoinData();
      this.getOutputInfo();
    } else {
      routerJump('preview', {
        id: this.partyCode,
        slotNum: URL.query.slotNum
      });
    }
    Bus.$on('pageSerBusCallback', v => {
      this.pageSerBusCallback(v);
    });
    Bus.$off('removeParticipant');
    Bus.$on('removeParticipant', v => {
      if (v.rtilCode == this.userInfo.rtilCode) {
        routerJump('remove');
      }
    });
    Bus.$on('setOutput', v => {
      const {
        rtilCode,
        slotNum
      } = v;
      this.mainwindowInfo.forEach(item => {
        if (item.slotNum == slotNum) item.mainWindowRtilCode = rtilCode;
      });
      if (slotNum != this.currentSlotNum) return;
      this.outputRtilCode = rtilCode;
      // 如果 ws 消息比 Agora 推送有人加入慢的话需要额外处理删除 mainwindow
      if (this.rtilCodeList.includes(rtilCode)) {
        this.rtilCodeList = this.rtilCodeList.filter(item => item != rtilCode);
      }
    });
    Bus.$on('cancelOutput', v => {
      const {
        slotNum
      } = v;
      this.mainwindowInfo.forEach(item => {
        if (item.slotNum == slotNum) item.mainWindowRtilCode = '';
      });
      if (slotNum != this.currentSlotNum) return;
      this.outputRtilCode = '';
    });
    Bus.$on('setBehaviors', v => {
      const behaviors = v.behaviors;
      behaviors.forEach(val => {
        if (val.key == 'nickName') {
          this.$set(this.nickNameMap, val.mark, val.value);
        }
      });
    });
    Bus.$on('endParty', v => {
      routerJump('remove', {
        type: 'end'
      });
    });
    Bus.$on('flipVideo', v => {
      this.$set(this.degreeHost, v.rtilCode, v.degree);
    });
    Bus.$on('controlBehavior', async v => {
      const {
        rtilCode,
        behavior,
        senderRtilCode
      } = v;
      const {
        key,
        value
      } = behavior;
      const changeToBooleanVal = value === 'true';
      if (rtilCode == this.userInfo.rtilCode) {
        if (key == 'camera') {
          // 避免之后多host控制与会者device，用于记录操作host的rtilCode，以最后一次操作的host为准
          this.$set(this.hostControlPipRtilCode, 'camera', senderRtilCode);
          if (!changeToBooleanVal) {
            controlCamera(this.rtc, this.devicesInfo, changeToBooleanVal, result => {
              if (result === 'failed') {
                this.$message.warning(this.$t('common.hostOperationCameraFailed'));
                // 操作失败，给host发送消息
                this.sendToHost('camera', 3);
              }
            });
            controlDeviceBehavior({
              senderRtilCode: this.userInfo.rtilCode,
              type: 'camera',
              value: value === 'true',
              partyCode: this.userInfo.realPartyCode,
              toRtilCode: this.userInfo.rtilCode,
              origin: 'InterviewHost'
            });
            this.$message.warning(this.$t('commonFunction.hasCameraOff'));
          } else {
            this.CameraTips.hideSave = false;
            this.CameraTips.hideCancel = false;
            this.CameraTips.showGotIt = false;
            this.CameraTips.show = true;
            this.CameraTips.content = `<div class="end">${this.$t('galleryParticipant.cameraTipCon')}</div>`;
          }
        }
        if (key == 'mic') {
          var _this$rtc;
          // 避免之后多host控制与会者device，用于记录操作host的rtilCode，以最后一次操作的host为准
          this.$set(this.hostControlPipRtilCode, 'mic', senderRtilCode);
          let operationResult = 'success';
          if ((_this$rtc = this.rtc) !== null && _this$rtc !== void 0 && _this$rtc._localAudioTrack && this.rtcLoaded) {
            const type = changeToBooleanVal ? 'publish' : 'unpublish';
            operationResult = await controlDevicePublish(this.rtc, type, [this.rtc._localAudioTrack]);
          } else {
            // 初始化的时候没有本地音频轨道，需要重新获取
            controlAudio(this.rtc, this.devicesInfo, changeToBooleanVal, result => {
              if (result != 'failed' && changeToBooleanVal) {
                var _this$rtc2;
                // 为了可以听见自己声音的功能添加的
                if (this.State.startHearSelf && this.hearSelf && (_this$rtc2 = this.rtc) !== null && _this$rtc2 !== void 0 && _this$rtc2._localAudioTrack) {
                  this.rtc.play(this.rtc._localAudioTrack, '', {
                    type: 'audio'
                  });
                }
              } else {
                operationResult = 'failed';
              }
            });
          }
          if (operationResult === 'success') {
            controlDeviceBehavior({
              senderRtilCode: this.userInfo.rtilCode,
              type: 'mic',
              value: changeToBooleanVal,
              partyCode: this.userInfo.realPartyCode,
              toRtilCode: this.userInfo.rtilCode,
              origin: 'InterviewHost'
            });
          } else {
            this.$message.warning(this.$t('common.hostOperationMicroFailed'));
            // 操作失败，给host发送消息
            this.sendToHost('mic', 3);
          }
          this.$message.warning(changeToBooleanVal ? this.$t('remainWords.hostHasMicrophoneOn') : this.$t('commonFunction.hasMicrophoneOff'));
        }
        if (key == 'nickName' && this.nickNameMap[rtilCode]) {
          this.$set(this.nickNameMap, rtilCode, value);
        }
      }
    });
    Bus.$on('intercom', v => {
      var _this$userInfo$manage;
      const {
        receiveRtilCode,
        startRtilCode,
        value
      } = v;
      const isHostPrivateWidthMe = (_this$userInfo$manage = this.userInfo.managerRtils) === null || _this$userInfo$manage === void 0 ? void 0 : _this$userInfo$manage.includes(startRtilCode);
      if (startRtilCode == this.rtilCode) {
        if (value === 'true') {
          !this.rtilCodeList.includes(receiveRtilCode) && this.rtilCodeList.push(receiveRtilCode);
        } else {
          var _this$trackMap$receiv, _this$trackMap$receiv2;
          this.rtilCodeList = this.rtilCodeList.filter(rtilCode => rtilCode != receiveRtilCode);
          // 停止之前私聊人的声音
          (_this$trackMap$receiv = this.trackMap[receiveRtilCode]) === null || _this$trackMap$receiv === void 0 ? void 0 : (_this$trackMap$receiv2 = _this$trackMap$receiv.audioTrack) === null || _this$trackMap$receiv2 === void 0 ? void 0 : _this$trackMap$receiv2.stop();
        }
      } else if (receiveRtilCode == this.rtilCode) {
        if (value === 'true') {
          if (this.rtilCodeList.includes(startRtilCode)) return;
          isHostPrivateWidthMe ? this.rtilCodeList.splice(1, 0, startRtilCode) : this.rtilCodeList.push(startRtilCode);
        } else {
          var _this$trackMap$startR, _this$trackMap$startR2;
          this.rtilCodeList = this.rtilCodeList.filter(rtilCode => rtilCode != startRtilCode);
          (_this$trackMap$startR = this.trackMap[startRtilCode]) === null || _this$trackMap$startR === void 0 ? void 0 : (_this$trackMap$startR2 = _this$trackMap$startR.audioTrack) === null || _this$trackMap$startR2 === void 0 ? void 0 : _this$trackMap$startR2.stop();
        }
      }
      // 维护私聊 map 对象
      if (value === 'true') {
        !this.State.startPrivateInfo[startRtilCode] && this.$set(this.State.startPrivateInfo, startRtilCode, [receiveRtilCode]);
        !this.State.startPrivateInfo[startRtilCode].includes(receiveRtilCode) && this.State.startPrivateInfo[startRtilCode].push(receiveRtilCode);
      } else {
        var _this$State$startPriv;
        (_this$State$startPriv = this.State.startPrivateInfo)[startRtilCode] && (_this$State$startPriv[startRtilCode] = this.State.startPrivateInfo[startRtilCode].filter(rtilCode => rtilCode != receiveRtilCode));
      }
    });
    // 获取rtil对应的R的状态
    Bus.$on('rtilLiveStatus', v => {
      this.liveInfo = v;
    });
    Bus.$emit('createWs', {
      ...this.State.config,
      partyCode: URL.query.id
    });
  },
  mounted() {
    if (!this.State.volumeBar) {
      this.State.volumeBar = new VolumeBar();
    }
    this.changeLayout();
  },
  methods: {
    pageSerBusCallback({
      socket,
      partyCode
    }) {
      this.updataInfoTimer = setInterval(() => {
        if (socket.client.readyState === 1) {
          const params = {
            data: JSON.stringify({
              data: JSON.stringify({
                rtilCodes: this.allRtilCodeList,
                businessId: partyCode
              }),
              module: 'rtilLiveStatus',
              type: 'rtilLiveStatus'
            }),
            serverName: 'partyline'
          };
          socket.send(params);
        }
      }, 1000);
    },
    agoraCallback({
      action,
      payload
    }) {
      switch (action) {
        case 'local-track':
          const {
            id,
            videoTrack,
            audioTrack
          } = payload;
          this.$set(this.trackMap, id, {
            id,
            channel: this.partyCode,
            videoTrack,
            audioTrack,
            showLocal: true
          });
          break;
        case 'user-joined':
          this.userJoin(payload);
          break;
        case 'user-left':
          this.userLeave(payload);
          break;
        case 'user-published':
        case 'user-unpublished':
          this.userPublished(action, payload);
          break;
        case 'subscribe-track':
          this.subscribeTrack(payload);
          break;
      }
    },
    async userJoin(payload) {
      const {
        id
      } = payload;
      if (!id) return;
      this.allRtilCodeList.push(id);
      this.$set(this.trackMap, id, {
        id,
        channel: this.partyCode
      });
      this.$set(this.State.micStatus, id, false);
      this.$set(this.State.cameraStatus, id, false);
      this.getNickName(id);
    },
    userLeave(payload) {
      const {
        id
      } = payload;
      this.$delete(this.trackMap, id);
      this.$delete(this.nickNameMap, id);
      this.$delete(this.State.micStatus, id);
      this.$delete(this.State.cameraStatus, id);
      this.allRtilCodeList = this.allRtilCodeList.filter(rtilCode => rtilCode != id);
      if (this.outputRtilCode == id) this.outputRtilCode = '';
      this.rtilCodeList = this.rtilCodeList.filter(item => item != id);
    },
    userPublished(action, payload) {
      const {
        id,
        mediaType
      } = payload;
      const val = action === 'user-published';
      mediaType === 'video' ? this.$set(this.State.cameraStatus, id, val) : this.$set(this.State.micStatus, id, val);
    },
    subscribeTrack(payload) {
      const {
        id,
        channel,
        videoTrack,
        audioTrack
      } = payload;
      if (id && !this.trackMap[id]) this.$set(this.trackMap, id, {});
      this.$set(this.trackMap, id, {
        id,
        channel,
        videoTrack,
        audioTrack
      });
      this.$nextTick(() => {
        this.changeLayout();
      });
    },
    getNickName(id) {
      const params = {
        originRtilCode: this.userInfo.rtilCode,
        annotation: this.partyCode,
        keys: ['avatar', 'nickName', 'interviewSlot', 'flipVideo'],
        marks: [id]
      };
      this.axios.post('/partyline-backend/behavior/noLogin/getList', params).then(res => {
        if (res.data.errorCode === '0x0') {
          var _this$State$startPriv2, _this$State$startPriv3;
          const result = res.data.result[id];
          this.$set(this.nickNameMap, id, result.nickName);
          this.$set(this.avatarInfo, id, result.avatar);
          this.$set(this.degreeHost, id, result.flipVideo);
          result.interviewSlot && this.$set(this.slotNumList, id, result.interviewSlot);
          /**
           * 1. 不能重复加入
           * 2. 不能是 mainwindow 的 rtilCode
           * 3. 并且只有在和与会者私聊时 rtilCode 才会被显示出来
           */
          if (!this.rtilCodeList.includes(id) && this.outputRtilCode != id && ((_this$State$startPriv2 = this.State.startPrivateInfo[id]) !== null && _this$State$startPriv2 !== void 0 && _this$State$startPriv2.includes(this.rtilCode) || (_this$State$startPriv3 = this.State.startPrivateInfo[this.rtilCode]) !== null && _this$State$startPriv3 !== void 0 && _this$State$startPriv3.includes(id))) {
            var _this$userInfo$manage2;
            (_this$userInfo$manage2 = this.userInfo.managerRtils) !== null && _this$userInfo$manage2 !== void 0 && _this$userInfo$manage2.includes(id) ? this.rtilCodeList.splice(1, 0, id) : this.rtilCodeList.push(id);
          }
        }
      });
    },
    changeLayout() {
      var _this$$refs$interview, _this$$refs$interview2;
      const percent = 16 / 9;
      const videoCanvasWidth = (_this$$refs$interview = this.$refs.interviewBox) === null || _this$$refs$interview === void 0 ? void 0 : _this$$refs$interview.clientWidth;
      const videoCanvasHeight = ((_this$$refs$interview2 = this.$refs.interviewBox) === null || _this$$refs$interview2 === void 0 ? void 0 : _this$$refs$interview2.clientHeight) - 20; // 需要减去 padding值
      // 根据屏幕的自适应获取可适应的16:9的宽度
      if (videoCanvasWidth / percent > videoCanvasHeight) {
        // 画布的高不够，需要减少画布的宽，计算出在此高度下的最大宽
        // 为了能更多的占用空间
        if (this.rtilCodeList.length >= 2) {
          this.videoCanvasWidth = `${(videoCanvasHeight + 150) * percent}px`;
        } else {
          this.videoCanvasWidth = `${videoCanvasHeight * percent}px`;
        }
      } else {
        this.videoCanvasWidth = '90%';
      }
    },
    async getBehaviorsByMemberId() {
      var _behaviors$rtilCode;
      if (!this.partyCode.trim()) return '';
      const params = {
        memberId: handleLocalStorage('get', 'memberId') || 'PL_' + new Date().getTime(),
        annotation: this.partyCode.trim(),
        keys: ['nickName']
      };
      handleLocalStorage('set', 'memberId', params.memberId);
      const res = await this.axios.post('/partyline-backend/behavior/noLogin/getListByMemberId', params);
      const result = res.data.result;
      const {
        rtilCode,
        behaviors
      } = result;
      if (res.data.errorCode == '0x0' && rtilCode) this.$set(this.nickNameMap, rtilCode, behaviors[rtilCode].nickName);
      return {
        rtilCode,
        nickName: behaviors === null || behaviors === void 0 ? void 0 : (_behaviors$rtilCode = behaviors[rtilCode]) === null || _behaviors$rtilCode === void 0 ? void 0 : _behaviors$rtilCode.nickName
      };
    },
    getOutputInfo() {
      if (!this.partyCode) return;
      const params = {
        partyCode: this.partyCode
      };
      this.axios.post('/partyline-backend/interview/noLogin/queryInterviewSlot', params).then(res => {
        if (res.data.errorCode == '0x0') {
          const result = res.data.result;
          result.forEach(item => {
            if (item.slotNum == this.currentSlotNum) {
              this.outputRtilCode = item.mainWindowRtilCode;
            }
            if (item.participantRtilCode) this.$set(this.slotNumList, item.participantRtilCode, item.slotNum);
            this.mainwindowInfo.push(item);
          });
        }
      });
    },
    getJoinData() {
      const haveHistoryMem = handleLocalStorage('get', 'memberId');
      const params = {
        memberId: haveHistoryMem || 'PL_' + new Date().getTime(),
        partyCode: this.partyCode,
        role: 0,
        type: 0,
        host: false,
        slotNum: this.currentSlotNum,
        behaviors: [{
          key: 'interviewSlot',
          value: this.currentSlotNum,
          annotation: this.partyCode
        }],
        behaviorKeyList: ['speaker', 'nickName', 'mic', 'camera', 'flipVideo']
      };
      this.axios.post('/partyline-backend/party/noLogin/join', params, {
        routeName: this.$route.query.from,
        errorTip: false
      }).then(async res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          const {
            rtilCode,
            behavior,
            title,
            createTime,
            joinCode
          } = result;
          this.rtilCode = rtilCode;
          this.userInfo = result;
          this.State.partyCode = joinCode;
          this.$set(this.slotNumList, rtilCode, this.currentSlotNum);
          if (!this.allRtilCodeList.includes(rtilCode)) this.allRtilCodeList.push(rtilCode);
          Bus.$emit('changePartyAddress', {
            currentId: this.partyCode,
            title: title,
            createTime
          });
          if (!this.rtilCodeList.includes(rtilCode)) this.rtilCodeList.push(rtilCode);
          // 存旋转度数
          this.$set(this.degreeHost, result.rtilCode, behavior.flipVideo);
          // 如果没有摄像头，则默认图标禁用
          this.State.isMute = behavior.speaker !== 'true';
          this.State.initCamera = this.devicesInfo.cameraId ? behavior.camera === 'false' : true;
          this.$set(this.State.cameraStatus, result.rtilCode, this.devicesInfo.cameraId ? behavior.camera === 'true' : false);
          this.$set(this.State.micStatus, result.rtilCode, this.devicesInfo.microphoneId ? behavior.mic === 'true' : false);
          await this.getAllPrivate();
          await this.joinAgora(result);
        }
      });
    },
    async getAllPrivate() {
      if (!this.partyCode) return;
      const params = {
        annotation: this.partyCode,
        key: 'privateChat',
        value: true
      };
      await this.axios.post('/partyline-backend/userkkv/noLogin/getPartyCodeKey', params).then(async res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          result.forEach(item => {
            const mark = Number(item.mark);
            const subKey = Number(item.subKey);
            const remark = Number(item.remark);
            if (!this.State.startPrivateInfo[mark]) {
              this.$set(this.State.startPrivateInfo, mark, [subKey]);
            } else {
              if (!this.State.startPrivateInfo[mark].includes(subKey)) this.State.startPrivateInfo[mark].push(subKey);
            }
            if (remark && remark == this.userInfo.rtilCode && !this.State.localSendPrivateArray.includes(subKey)) {
              this.State.localSendPrivateArray.push(subKey);
            }
          });
        }
      });
    },
    async joinAgora(result) {
      var _this$rtc3;
      const {
        appId,
        tokenCode,
        rtilCode,
        realPartyCode,
        videoQualities
      } = result;
      const params = {
        appId,
        channel: realPartyCode + '',
        token: tokenCode,
        uid: rtilCode,
        cameraSolution: '720p_2',
        videoConfig: videoQualities,
        codec: 'h264',
        publishVideo: this.State.cameraStatus[result.rtilCode],
        publishAudio: this.State.micStatus[result.rtilCode],
        video: !!this.devicesInfo.cameraId && this.State.cameraStatus[result.rtilCode],
        audio: !!this.devicesInfo.microphoneId && this.State.micStatus[result.rtilCode],
        cameraId: this.devicesInfo.cameraId,
        microphoneId: this.devicesInfo.microphoneId,
        executeLocalSubscribe: false
      };
      await ((_this$rtc3 = this.rtc) === null || _this$rtc3 === void 0 ? void 0 : _this$rtc3.join(params));
      this.rtcLoaded = true;
    },
    operateList(rtilCode) {
      return this.rtilCode == rtilCode ? ['rename', 'fullScreen'] : ['fullScreen'];
    },
    dealAttendCallback(info) {
      const {
        type,
        val
      } = info;
      switch (type) {
        case 'muteAudio':
          this.setAudio(val);
          break;
        case 'muteVideo':
          this.setVideo(val);
          break;
        case 'fullScreen':
          if (val && getFullscreenEnabled()) {
            document.documentElement.requestFullscreen && document.documentElement.requestFullscreen();
          }
          break;
      }
    },
    dealFootEvent(info) {
      const {
        type,
        val
      } = info;
      switch (type) {
        case 'muteVideo':
          this.setVideo(val);
          break;
        case 'muteAudio':
          this.setAudio(val);
          break;
        case 'changeMute':
          this.setSpeaker(val);
          break;
        case 'changeDevice':
          this.switchDevice(val);
          break;
        case 'leave':
          const receiverCodeList = this.rtilCodeList.filter(item => {
            var _this$userInfo$manage3;
            return item != this.userInfo.rtilCode && item != this.mainWindowRtilCode && !((_this$userInfo$manage3 = this.userInfo.managerRtils) !== null && _this$userInfo$manage3 !== void 0 && _this$userInfo$manage3.includes(item));
          });
          Bus.$emit('showDialog', {
            show: true,
            realPartyCode: this.partyCode,
            rtilCode: this.rtilCode,
            slotNum: this.currentSlotNum,
            receiverCodeList: receiverCodeList
          });
          break;
      }
    },
    async setVideo(val) {
      if (!this.rtcLoaded) return;
      if (val) {
        this.State.showInitCameraTips = true;
        this.$set(this.State.cameraStatus, this.userInfo.rtilCode, true);
      }
      await controlCamera(this.rtc, this.devicesInfo, val);
      controlDeviceBehavior({
        senderRtilCode: this.userInfo.rtilCode,
        type: 'camera',
        value: val,
        partyCode: this.userInfo.realPartyCode,
        toRtilCode: this.userInfo.rtilCode,
        origin: 'commonPartyHost',
        notChangeStatus: true
      });
      this.State.initCamera = !val;
    },
    async setAudio(val) {
      if (!this.rtcLoaded) return;
      let operationResult = 'success';
      if (this.rtc._localAudioTrack) {
        const type = val ? 'publish' : 'unpublish';
        operationResult = await controlDevicePublish(this.rtc, type, [this.rtc._localAudioTrack]);
      } else {
        // 初始化的时候没有本地音频轨道，需要重新获取
        controlAudio(this.rtc, this.devicesInfo, val, result => {
          if (result == 'failed') operationResult = 'failed';
        });
      }
      if (operationResult === 'success') {
        controlDeviceBehavior({
          senderRtilCode: this.userInfo.rtilCode,
          type: 'mic',
          value: val,
          partyCode: this.userInfo.realPartyCode,
          toRtilCode: this.userInfo.rtilCode,
          origin: 'commonPartyHost',
          notChangeStatus: true
        });
      }
    },
    setSpeaker(val) {
      this.$store.commit('isMute', val);
      const messageText = val ? this.$t('galleryParticipant.websiteSoundOff') : this.$t('galleryParticipant.websiteSoundOn');
      this.$message({
        type: 'success',
        message: messageText
      });
      changeBehaviorStatus({
        key: 'speaker',
        rtilCode: this.userInfo.rtilCode,
        realPartyCode: this.userInfo.realPartyCode,
        value: !val
      });
    },
    switchDevice(info) {
      const {
        type,
        deviceId
      } = info;
      if (!this.rtc || !deviceId) return;
      if (type == 'speaker') {
        var _this$$refs$mainwindo;
        handleLocalStorage('set', 'speakerId', deviceId);
        // mainWindow切换
        if (this.outputRtilCode) (_this$$refs$mainwindo = this.$refs.mainwindow) === null || _this$$refs$mainwindo === void 0 ? void 0 : _this$$refs$mainwindo.setSpeakerAttendUser();
        // 与会者切换
        this.$nextTick(() => {
          this.rtilCodeList.forEach(rtilCode => {
            if (this.$refs[`remoteSource${rtilCode}`][0] && rtilCode != this.outputRtilCode && rtilCode != this.rtilCode) {
              this.$refs[`remoteSource${rtilCode}`][0].setSpeakerAttendUser();
            }
          });
        });
      }
      this.rtc.setDevice(deviceId, type, result => {
        if (type == 'audio' && result === 'success') {
          // this.$refs.pipBox.reUseAudioWorklet()
          // this.detecteMicMuted()
        }
        if (type === 'video' && result === 'success' && !this.State.cameraStatus[this.rtilCode]) {
          var _this$rtc4;
          ((_this$rtc4 = this.rtc) === null || _this$rtc4 === void 0 ? void 0 : _this$rtc4._localVideoTrack) && this.rtc._localVideoTrack.setEnabled(false);
        }
      });
    },
    setCameraStatus() {
      controlCamera(this.rtc, this.devicesInfo, true);
      controlDeviceBehavior({
        senderRtilCode: this.userInfo.rtilCode,
        type: 'camera',
        value: true,
        partyCode: this.userInfo.realPartyCode,
        toRtilCode: this.userInfo.rtilCode,
        origin: 'interviewHost'
      });
    },
    sendToHost(type, value) {
      const params = {
        module: 'responseControlBehavior',
        partyCode: this.partyCode,
        origin: 'InterviewParticipate',
        msg: {
          key: type,
          senderRtilCode: this.userInfo.rtilCode,
          rtilCode: this.hostControlPipRtilCode[type],
          responseCode: value
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=30228', params);
    }
  },
  beforeRouteLeave(to, from, next) {
    var _this$rtc5;
    (_this$rtc5 = this.rtc) === null || _this$rtc5 === void 0 ? void 0 : _this$rtc5.leave();
    window.removeEventListener('resize', this.changeLayout);
    if (this.State.volumeBar) this.State.volumeBar.destroyAudioContext();
    next();
  }
};